<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@modalSendPdfByEmailTitle" id="modal-header">Send Email to:</h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.close()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="emailsForm">
      <div formArrayName="emails">
        @for (email of emails.controls; track email; let i = $index) {
          <div>
            <div [formGroup]="email" class="email-list">
              <input
                type="checkbox"
                (change)="createEmailList()"
                [checked]="email.get('selected')?.value"
                formControlName="selected"
                [attr.aria-label]="'Select email ' + email.get('email')?.value"
              />
              {{ email.get('email')?.value }}
            </div>
          </div>
        }
      </div>
    </form>

    <form [formGroup]="addEmailForm">
      <p class="additional-email" i18n="@@AdditionalEmail">Additional Email</p>
      <input
        appInput
        [border]="true"
        [noIcon]="true"
        type="text"
        formControlName="email"
        i18n-placeholder
        placeholder="Enter an additional email to send to"
        aria-label="Additional email address"
      />
    </form>
    <button
      type="button"
      id="button_add_email"
      appButton="small"
      class="add-email-button"
      aria-label="Add an email"
      i18n-aria-label
      (click)="addEmail()"
      [disabled]="addEmailForm.invalid"
      (keydown.enter)="addEmail()"
      (keydown.space)="addEmail()"
      i18n="@@modalAddEmail"
    >
      Add
    </button>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      appButton="small"
      class="small-button--close"
      aria-label="Cancel"
      (click)="activeModal.close()"
      (keydown.enter)="activeModal.close()"
      (keydown.space)="activeModal.close()"
      i18n="@@modalCancel"
    >
      Cancel
    </button>
    <button
      type="button"
      id="button_send"
      appButton="small"
      aria-label="Save and Continue"
      i18n-aria-label
      (click)="submit()"
      [disabled]="!emailsList.length"
      (keydown.enter)="submit()"
      (keydown.space)="submit()"
      i18n="@@modalSend"
    >
      Send
    </button>
  </div>
</div>
